
const getInitialCart = () => {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  };
  
  const handleCart = (state = getInitialCart(), action) => {
    const product = action?.payload;
    let updatedCart;
    switch (action.type) {
      case "ADDITEM":
        const exist = state.find((x) => x.product_variant_id === product.product_variant_id);
        if (exist && product.addone) {
          delete product.addone
          updatedCart = state.map((x) =>
            x.product_variant_id === product.product_variant_id ? { ...x, quantity: x.quantity + 1 } : x
          );
          
        }else if(exist){
          updatedCart = state.map((x) =>
            x.product_variant_id === product.product_variant_id ? { ...x, quantity: x.quantity + product.quantity } : x
          );
        }
         else {
          updatedCart = [...state, { ...product, quantity: product.quantity }];
        }
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart;

        case "ADDONE":
          const exist4 = state.find((x) => x.product_variant_id === product.product_variant_id);
          if (exist4) {
            updatedCart = state.map((x) =>
              x.product_variant_id === product.product_variant_id ? { ...x, quantity: x.quantity + 1 } : x
            );
            
          }
           else {
            updatedCart = [...state, { ...product, quantity: product.quantity }];
          }
          localStorage.setItem("cart", JSON.stringify(updatedCart));
          return updatedCart;
  
      case "DELITEM":
        const exist2 = state.find((x) => x.product_variant_id === product.product_variant_id);
        if (exist2.quantity === 1) {
          updatedCart = state.filter((x) => x.product_variant_id !== exist2.product_variant_id);
        } else {
          updatedCart = state.map((x) =>
            x.product_variant_id === product.product_variant_id ? { ...x, quantity: x.quantity - 1 } : x
          );
        }
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart; 

      case "DELALLQTY":
        const exist3 = state.find((x) => x.product_variant_id === product.product_variant_id);
        if (exist3.quantity >0) {
          updatedCart = state.filter((x) =>( x.product_variant_id !== exist3.product_variant_id));
        } else {
          updatedCart = state.map((x) =>
            x.product_variant_id === product.product_variant_id ? { ...x, quantity: x.quantity - x.quantity } : x
        );
      }
      localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart;
        
  
      case "DELALLITEM":
          localStorage.removeItem("cart");
          return [];
      
      case "REFERESH":
             const exist5 = localStorage.getItem("cart")
             updatedCart = JSON.parse(exist5) 
            return updatedCart ;
  
      default:
        return state;
    }
  
  };
  
  
  export default handleCart;